import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { JVInput } from "../../shared/JVInput";
import { IIpConfig, EmptyIpConfig } from "./EmptyIpConfig";
import { JVDropdown } from "../../shared/JVDropdown";
import { IBranchMastDropdown, ICompanyMastDropdown } from "../../models/IDropdown";

const schema = yup.object({
    company_ID: yup.number().min(1, "Company is required*").required("Company is required*"),
    branch_ID: yup.number().min(1, "Branch is required*").required("Branch is required*"),
    branch_IP: yup.string().required("Branch IP is required*")
});

interface Iprops {
    singleData: IIpConfig,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void
}

export const Form = (props: Iprops) => {
    const [companies, setCompanies] = useState<Array<ICompanyMastDropdown>>();
    const [branches, setBranches] = useState<Array<IBranchMastDropdown>>();
    const [f_branches, setF_Branches] = useState<Array<IBranchMastDropdown>>();

    const { control, handleSubmit, formState: { errors }, reset, watch } = useForm<IIpConfig>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false
    });

    useEffect(() => {
        reset(props.singleData);
    }, [props.singleData]);

    const loadBranches = async () => {
        const response = await Fetch("Dropdown/branches", "GET", null, null, null);
        if (response) {
            const data: Array<IBranchMastDropdown> = await response.json();
            setBranches(data);
        }
    }
    const loadCompanies = async () => {
        const response = await Fetch("Dropdown/company", "GET", null, null, null);
        if (response) {
            const data: Array<ICompanyMastDropdown> = await response.json();
            setCompanies(data);
        }
    }

    useEffect(() => {
        loadCompanies();
        loadBranches();
    }, []);

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (companies && branches && name === "company_ID") {
                if (value.company_ID) {
                    const selectedCompany = companies.find(company => company.company_ID === value.company_ID);
                    if (selectedCompany) {
                        const t_branches = branches.filter(branch => branch.branchName.includes(selectedCompany.company_Name));
                        setF_Branches(t_branches);
                    } else setF_Branches(undefined);
                }
                else setF_Branches(undefined);
            }
        });
        return () => subscription.unsubscribe();
    }, [watch, companies, branches]);

    const saveToDB = async (body: IIpConfig) => {
        const method = props.singleData.branch_ID ? "PUT" : "POST";
        const message = props.singleData.branch_ID ? "Updated Successfully" : "Added Successfully";

        const response = await Fetch("Branch_Ips", method, body, null, props.toast);

        if (response) {
            onHide();
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            props.setReload(!props.reload);
        }
    }

    const onHide = () => {
        props.hideDialog();
        reset(EmptyIpConfig);
    }

    function onSubmit(data: IIpConfig) {
        saveToDB(data);
    }

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Edit Company" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">

                <JVDropdown required label="Company" control={control} name="company_ID" options={companies} optionLabel="company_Name" optionValue="company_ID" placeholder="Select Company" error={errors.company_ID?.message} />
                <JVDropdown required label="Branch" control={control} name="branch_ID" options={f_branches} optionLabel="branchName" optionValue="branch_ID" placeholder="Select Branch" error={errors.branch_ID?.message} />
                <JVInput required label="Branch IP" control={control} name="branch_IP" error={errors.branch_IP?.message} maxLength={50} />
                {/* <div className="col-12 md:col-12">
                    <Button className="field col-12 md:col-6" label="SAVE" type="submit"></Button>
                    <Button className="field col-12 md:col-6 p-button-outlined" label="CLOSE" onClick={onHide} type="button"></Button>
                </div> */}
                  <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                    <Button style={{ width: '100px' }} label="SAVE" type="submit"></Button>
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-outlined surface-200"></Button>
                </div>
            </form>
        </Dialog>
    );
}
